import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'leaflet';
import { EventService } from 'src/app/core/services/event.service';
import { ApiService } from 'src/app/shared/services/api.service';
import Swal from 'sweetalert2';
import { saveAs } from 'file-saver';
import { MatDatepicker } from '@angular/material/datepicker';
@Component({
  selector: 'app-abort-request',
  templateUrl: './abort-request.component.html',
  styleUrls: ['./abort-request.component.scss']
})
export class AbortRequestComponent implements OnInit {


  constructor(
    private http: HttpClient,
    private apiService: ApiService,
    private modalService: NgbModal,
    public formBuilder: FormBuilder,
    private eventService: EventService,
    private translateService: TranslateService,
    private router: Router,

    // private modalService: NzModalService,
    // private notification: NzNotificationService
  ) { }
  searchTerm
  listData = []
  selectedFile: File | null = null;
  limit = 10
  page = 1
  params = ''
  searching
  totalCount = 0
  tableName = 'service-cancellation/admin/requests'
  role = JSON.parse(localStorage.getItem('currentUser'))['role']
  full_name = JSON.parse(localStorage.getItem('currentUser')).full_name;
  submitted: boolean
  formData: FormGroup
  listModel = ['MD712', 'MD716', 'MD760', 'Y50', 'Y56', 'F91']
  listVersion = ['Paybox', 'Soundbox']

  statusMap = {
    approved: 'Đã duyệt',
    rejected: 'Đã từ chối',
    pending: 'Đang chờ'
  };
  breadCrumbItems
  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl()
  });
  listDevices
  get form() {
    return this.formData.controls
  }
  filter = {
    phone: '',
    status: '',
    startDay: null,
    endDay: null,
    full_name: '',
    serial_number: ''
  }

  ngOnInit() {
    this.breadCrumbItems = [{ label: 'PAGE.HOME' }, { label: 'Yêu cầu hoàn hủy', active: true }];

    // THÊM: Gọi fetchData() khi component khởi tạo để tải dữ liệu lần đầu.
    this.fetchData();

    this.range.valueChanges.subscribe((rangeValues) => {
      const formatDate = (date: Date | null) => {
        if (!date) return null;
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };
      this.filter.startDay = formatDate(rangeValues.start);
      this.filter.endDay = formatDate(rangeValues.end);
    });
  }
  date = new FormGroup({
    selectedMonth: new FormControl(null), // Không dùng <Date | null>
  });



  selectedMonth: { month: string; year: string } | null = null;
  onMonthSelected(event: Date, datepicker: MatDatepicker<Date>) {
    const year = event.getFullYear();
    const month = event.getMonth(); // Không cần +1 vì Date đã đúng format

    // Gán giá trị vào FormControl
    this.date.controls['selectedMonth'].setValue(new Date(year, month, 1));

    console.log('📅 Tháng được chọn:', { month: month + 1, year });

    datepicker.close(); // Đóng datepicker sau khi chọn
  }


  logDateRange(start: Date | null, end: Date | null) {
    console.log('Start date:', start);
    console.log('End date:', end);
  }
  onChangePage(e) {
    this.page = e
    this.fetchData()
  }
  handleOrder(data) {
    Swal.fire({
      title: this.translateService.instant('FORM.Warning'),
      text: this.translateService.instant('Bạn có chắc chắn muốn tạo đơn hàng?'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#34c38f',
      cancelButtonColor: '#ff3d60',
      confirmButtonText: this.translateService.instant('FORM.WarningConfirm'),
      cancelButtonText: this.translateService.instant('FORM.Cancel')
    }).then((result) => {
      if (result.isConfirmed) {
        this.apiService.postItem(`admin/customer-orders/` + data.id, {}).subscribe({
          next: () => {
            this.apiService.showToastMobile(
              this.translateService.instant('success'),
              this.translateService.instant('Tạo đơn hàng thành công')
            );
            this.fetchData();
          },
          error: (err) => {
            if (err === 'Internal Server Error') {
              this.apiService.showToastMobile(
                'error',
                this.translateService.instant('Lỗi máy chủ')
              );
            } else {
              this.apiService.showToastMobile(
                'error',
                err
              );
            }
          },
        });
      }
    });
  }
  onLink(data, contentLink) {
    this.getCountDevice(data.id)
    this.formData = this.makeForm(data)
    this.modalService.open(contentLink, { centered: true, scrollable: true, size: 'xl' });
  }

  clearFilter() {
    this.params = '';
    this.filter = {
      phone: '',
      status: '',
      startDay: null,
      endDay: null,
      full_name: '',
      serial_number: ''
    };
    this.range.reset();
    this.page = 1;
    this.searching = false;
    this.fetchData();
  }

  submitFilter() {
    this.page = 1; // Reset về trang đầu tiên khi có bộ lọc mới
    this.params = '';
    Object.keys(this.filter).forEach(key => {
      const value = this.filter[key];
      if (value !== null && value !== '' && value !== undefined) {
        this.params += `&${key}=${encodeURIComponent(value)}`;
      }
    });
    this.searching = !!this.params;
    this.fetchData();
  }


  fetchData() {
    this.eventService.setLoading(true);

    const url = `${this.tableName}?page=${this.page}&limit=${this.limit}${this.params || ''}`;

    this.apiService.getList(url).subscribe({
      next: (res) => {
        let results = res.metadata?.results || [];
        this.totalCount = res.metadata?.pagination?.total || 0;

        if (this.filter.startDay || this.filter.endDay) {
          const start = this.filter.startDay ? new Date(`${this.filter.startDay}T00:00:00.000Z`) : null;
          const end = this.filter.endDay ? new Date(`${this.filter.endDay}T23:59:59.999Z`) : null;

          results = results.filter(item => {
            const created = new Date(item.created_at);
            if (start && end) {
              return created >= start && created <= end;
            }
            if (start) {
              return created >= start;
            }
            if (end) {
              return created <= end;
            }
            return true;
          });
        }

        this.listData = results;
        this.eventService.setLoading(false);
      },
      error: () => this.eventService.setLoading(false)
    });
  }



  countDevice
  getCountDevice(id) {
    this.apiService.getList('cs/device-subscription?customerOrderId=' + id
    ).subscribe({
      next: (res) => {
        this.formData.patchValue({
          quantity: res.metadata.missingDevices
        });
      }
    })
  }
  excelData: any;

  onFileChange(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      this.selectedFile = file;
    }
  }

  // Gửi file lên server
  uploadFile() {
    if (this.selectedFile) {
      const formData = new FormData();
      formData.append('file', this.selectedFile, this.selectedFile.name);

      this.http.post('device-stock', formData).subscribe(
        response => {
          console.log('File uploaded successfully', response);
        },
        error => {
          console.error('Error uploading file', error);
        }
      );
    } else {
      console.error('No file selected');
    }
  }
  addLang() {
    const language = this.form.language as FormArray
    let lang = this.makePrice()
    language.push(lang)
  }

  removeLang(i) {
    const language = this.form.language as FormArray
    language.removeAt(i)
  }

  openModal(content: any) {
    this.submitted = false
    this.formData = this.makeForm({ language: [{}] })
    let a = this.modalService.open(content, { centered: true, scrollable: true, size: 'lg' });
  }

  onEdit(data, content) {
    console.log(data)
    console.log(content)
    this.formData = this.makeForm(data)
    this.modalService.open(content, { centered: true, scrollable: true, size: 'xl' });
  }

  selectedIncident = null
  selectedKeyword = null

  makeFormKeyword(d) {
    let data = d ? d : <any>{}
    return this.formBuilder.group({
      id: [data.id],
      name: [data.name],
      incident_type_id: [data.incident_type_id]
    })
  }

  fetchKeyword() {
    this.dataKeyword = []
    this.eventService.setLoading(true)
    this.apiService.getList(`keyword?type_id=${this.selectedIncident.id}`).subscribe({
      next: res => {
        console.log(res)
        this.dataKeyword = [...res]
        this.eventService.setLoading(false)
      }
    })
  }

  dataKeyword = []

  formEditKeyword: FormGroup
  formNewKeyword: FormGroup
  editKeyword(data, index) {
    this.formEditKeyword = this.makeFormKeyword(data)
    this.selectedKeyword = data
  }

  onSubmitFormKeyword(type) {
    if (type == 1) {
      if (this.formEditKeyword.valid) {
        const value = this.formEditKeyword.value
        this.eventService.setLoading(true)
        this.apiService.editItem('keyword', value.id, value).subscribe({
          next: res => {
            this.selectedKeyword = null
            this.fetchKeyword()
            this.eventService.setLoading(false)

          }
        })
      }
    } else {
      if (this.formNewKeyword.valid) {
        const value = this.formNewKeyword.value
        this.eventService.setLoading(true)
        this.apiService.addItem('keyword', value).subscribe({
          next: res => {
            this.eventService.setLoading(false)
            this.formNewKeyword.reset({ incident_type_id: this.selectedIncident.id })
            this.fetchKeyword()
          }
        })
      }
    }
  }

  onOpenKeywordModal(content, incident) {
    this.selectedIncident = incident
    this.fetchKeyword()
    this.formNewKeyword = this.makeFormKeyword({ incident_type_id: this.selectedIncident.id })
    this.modalService.open(content, { centered: true, scrollable: true, size: 'xl' });
  }

  defaultPrices = [
    { condition: 1, price: 0, unit: '' },
    { condition: 2, price: 0, unit: '' }
  ]

  onDeleteKeyword(id) {
    if (id) {
      this.eventService.setLoading(true)
      this.apiService.deleteItem('keyword', id).subscribe(res => {

        Swal.fire(this.translateService.instant('FORM.Success'), this.translateService.instant('FORM.SuccessMessageDelete'), 'success')
          .then(
            res => {
              this.fetchKeyword();

            }
          )
        this.eventService.setLoading(false)

      }

      )
    }
  }

  onDelete(data) {
    Swal.fire({
      title: this.translateService.instant('FORM.Warning'),
      text: this.translateService.instant('FORM.WarningMessage'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#34c38f',
      cancelButtonColor: '#ff3d60',
      confirmButtonText: this.translateService.instant('FORM.WarningConfirm'),
      cancelButtonText: this.translateService.instant('FORM.Cancel')
    }).then(result => {
      if (result.value) {
        this.apiService.deleteItem(this.tableName, data).subscribe(res =>
          Swal.fire(this.translateService.instant('FORM.Success'), this.translateService.instant('FORM.SuccessMessageDelete'), 'success')
            .then(
              res => {
                this.fetchData();
              }
            )
        )
      }
    });
  }

  viewDetails(data: any) {
    this.router.navigate(['/orders-manager/detail-orders/', data.id]);
  }

  makeForm(d?) {
    let data = d ? d : <any>{}
    return this.formBuilder.group({
      id: [data.id],
      serial_number: [data.serial_number, [Validators.required]],
      quantity: [data.quantity - data.totalAttachedDevice],
      customer_name: [data.customer_name],
      workspace_id: [data.workspace_id],
      phone: [data.phone],
      address: [data.address],
      data: [`${data.customer_name || ''} - ${data.phone || ''} - ${data.address || ''}`],
    })
  }

  makePrices(data = []) {
    let arr = new FormArray([]);
    data.forEach(i => {

      arr.push(this.makePrice(i))
    })
    return arr;
  }

  makePrice(d?) {
    let data = d ? d : <any>{}
    return this.formBuilder.group({
      key: [data.key, [Validators.required]],
      // price: [data.price, [Validators.required, Validators.min(0)]],
      value: [data.value, [Validators.required]],
      // id: [data.id]
    })
  }

  uploadedImage

  saveData() {
    this.submitted = true
    if (this.formData.valid) {
      const value = this.formData.value
      value['status'] = value['status'] == true ? 1 : 0
      // value['prices'][0]['condition'] = 1
      // value['prices'][1]['condition'] = 2
      // value['price']= value['prices']
      this.eventService.setLoading(true)
      if (value.id) {
        this.apiService.editItem(this.tableName, value.id, value).subscribe({
          next: res => {
            this.submitted = false
            this.formData.reset()
            this.fetchData()
            this.modalService.dismissAll()
            this.apiService.showToast(this.translateService.instant('FORM.Success'), this.translateService.instant('FORM.SuccessMessage'), 'success')
            this.eventService.setLoading(false)
          },
          error: e => {
            this.apiService.showToast(this.translateService.instant('FORM.Error'), this.translateService.instant('FORM.ErrorMessage'), 'error')
            this.eventService.setLoading(false)
          }
        })
      } else {
        this.apiService.addItem(this.tableName, value).subscribe({
          next: res => {
            this.fetchData()
            this.apiService.showToast(this.translateService.instant('FORM.Success'), this.translateService.instant('FORM.SuccessMessageAdd'), 'success')
            this.eventService.setLoading(false)
            this.modalService.dismissAll()
          },
          error: e => {
            this.apiService.showToast(this.translateService.instant('FORM.Error'), this.translateService.instant('FORM.ErrorMessageAdd'), 'error')
            this.eventService.setLoading(false)
          }
        })
      }

    } else {
      console.log('invalid', this.formData)
      Object.values(this.formData.controls).forEach(control => {
        if (control.status == 'INVALID') {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }
  goToPreviousPage() {
    if (this.page > 1) {
      this.page--;
      this.fetchData();
    }
  }

  goToNextPage() {
    if (this.page < this.totalCount) {
      this.page++;
      this.fetchData();
    }
  }

  showCancelPopup = false;
  cancelData = { reason: '' };
  selectedOrder: any = null;

  openCancelPopup(order: any) {
    this.selectedOrder = order;
    this.cancelData.reason = order.reason || '';  // Lấy lý do từ table
    this.showCancelPopup = true;
  }

  closeCancelPopup() {
    this.showCancelPopup = false;
  }

  confirmCancel(status: 'approved' | 'rejected') {

    const payload = {
      id: this.selectedOrder.id,
      status: status,
      processed_by_note: this.cancelData.reason
    };

    this.http.patch('https://apiqrpay-dev.tomotek.vn/api/v1/service-cancellation/admin/process', payload)
      .subscribe({
        next: (res: any) => {
          this.apiService.showToastMobile('success', this.translateService.instant(res.metadata.message || "Tạo yêu cầu thành công"));
          this.closeCancelPopup();
          this.fetchData();
        },
        error: (e) => {
          console.error('Lỗi khi hủy đơn:', e);
          this.apiService.showToastMobile('error', this.translateService.instant(e || "Tạo yêu cầu huỷ thất bại"));
        }
      });
  }
}
